<template>
  <a-spin :spinning="confirmLoading">
    <j-form-container :disabled="formDisabled">
      <a-form :form="form" slot="detail">
        <a-row>
          <a-col :span="24">
            <a-form-item label="快递id" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['addressId']" placeholder="请输入快递id"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="收货地址" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['address']" placeholder="请输入收货地址"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="收货人" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['consignee']" placeholder="请输入收货人"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="收货人手机号" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['consigneePhone']" placeholder="请输入收货人手机号"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="订单状态" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['status']" placeholder="请输入订单状态"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="订单状态" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['statusShow']" placeholder="请输入订单状态"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="openid" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['openid']" placeholder="请输入openid"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="单价" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['price']" placeholder="请输入单价"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="数量" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['count']" placeholder="请输入数量"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="总价" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['amount']" placeholder="请输入总价"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="是否处理" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-switch v-decorator="['isChuli']" ></j-switch>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="是否处理" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['isChuliShow']" placeholder="请输入是否处理"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="微信订单号" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['outTradeNo']" placeholder="请输入微信订单号"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="药品id" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['yaopinId']" placeholder="请输入药品id"></a-input>
            </a-form-item>
          </a-col>
          <a-col v-if="showFlowSubmitButton" :span="24" style="text-align: center">
            <a-button @click="submitForm">提 交</a-button>
          </a-col>
        </a-row>
      </a-form>
    </j-form-container>
  </a-spin>
</template>

<script>

  import { httpAction, getAction } from '@/api/manage'
  import pick from 'lodash.pick'
  import { validateDuplicateValue } from '@/utils/util'
  import JFormContainer from '@/components/jeecg/JFormContainer'
  import JSwitch from '@/components/jeecg/JSwitch'

  export default {
    name: 'XinguanOrderForm',
    components: {
      JFormContainer,
      JSwitch,
    },
    props: {
      //流程表单data
      formData: {
        type: Object,
        default: ()=>{},
        required: false
      },
      //表单模式：true流程表单 false普通表单
      formBpm: {
        type: Boolean,
        default: false,
        required: false
      },
      //表单禁用
      disabled: {
        type: Boolean,
        default: false,
        required: false
      }
    },
    data () {
      return {
        form: this.$form.createForm(this),
        model: {},
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 },
        },
        confirmLoading: false,
validatorRules: {
},
        url: {
          add: "/xinguanOrder/xinguanOrder/add",
          edit: "/xinguanOrder/xinguanOrder/edit",
          queryById: "/xinguanOrder/xinguanOrder/queryById"
        }
      }
    },
    computed: {
      formDisabled(){
        if(this.formBpm===true){
          if(this.formData.disabled===false){
            return false
          }
          return true
        }
        return this.disabled
      },
      showFlowSubmitButton(){
        if(this.formBpm===true){
          if(this.formData.disabled===false){
            return true
          }
        }
        return false
      }
    },
    created () {
      //如果是流程中表单，则需要加载流程表单data
      this.showFlowData();
    },
    methods: {
      add () {
        this.edit({});
      },
      edit (record) {
        this.form.resetFields();
        this.model = Object.assign({}, record);
        this.visible = true;
        this.$nextTick(() => {
          this.form.setFieldsValue(pick(this.model,'addressId','address','consignee','consigneePhone','status','statusShow','openid','price','count','amount','isChuli','isChuliShow','outTradeNo','yaopinId'))
        })
      },
      //渲染流程表单数据
      showFlowData(){
        if(this.formBpm === true){
          let params = {id:this.formData.dataId};
          getAction(this.url.queryById,params).then((res)=>{
            if(res.success){
              this.edit (res.result);
            }
          });
        }
      },
      submitForm () {
        const that = this;
        // 触发表单验证
        this.form.validateFields((err, values) => {
          if (!err) {
            that.confirmLoading = true;
            let httpurl = '';
            let method = '';
            if(!this.model.id){
              httpurl+=this.url.add;
              method = 'post';
            }else{
              httpurl+=this.url.edit;
               method = 'put';
            }
            let formData = Object.assign(this.model, values);
            console.log("表单提交数据",formData)
            httpAction(httpurl,formData,method).then((res)=>{
              if(res.success){
                that.$message.success(res.message);
                that.$emit('ok');
              }else{
                that.$message.warning(res.message);
              }
            }).finally(() => {
              that.confirmLoading = false;
            })
          }
         
        })
      },
      popupCallback(row){
        this.form.setFieldsValue(pick(row,'addressId','address','consignee','consigneePhone','status','statusShow','openid','price','count','amount','isChuli','isChuliShow','outTradeNo','yaopinId'))
      },
    }
  }
</script>